import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FormModal, FormInput, SelectPaymentOptions } from '../../../../onestep-library/BaseUI'
import { isThisANumber } from '../../../../onestep-library/Validators/'
import Scheduler from '../../../Account/components/MasterNewChargeForm/components/Scheduler'
import moment from 'moment'
import { updateRecurringCharge, deleteRecurringCharge } from './actions'
import { injectStripe } from 'react-stripe-elements'
import { validateEditRecurringChargeForm } from './utils'
import moneyize from '../../../../onestep-library/TextPresenters/moneyize';

function EditRecurringCharge(props) {
  const dispatch = useDispatch()
  const { organization, resident, editRecurringChargeForm, paymentSources } = useSelector(state => state)
  const { ui, name, amount, payment_source, id, starts_at, interval, interval_count, ends_at, first_issue_date, next_issue_date, next_due_date_that_hasnt_been_issued,
    occurrences, end_type, has_credit_card_to_charge, invoice_client, is_stripe, first_due_date, receipt_email, receipt_note, email_receipt_to_payer,
    email, occurences, due_days_after_invoice, errors, is_cancelled, send_email_number_of_days_before_due_date, due_date, payment_method } = editRecurringChargeForm
  const { show, is_submitting, is_deleting } = ui
  const updateEditRecurringChargeField = (payload) => dispatch({ type: 'UPDATE_EDIT_RECURRING_CHARGE_FIELD', payload })

  function onClose() {
    dispatch({ type: 'RESET_EDIT_RECURRING_CHARGE', payload: { show: false } })
  }

  function onValidateRequiredFields() {
    return validateEditRecurringChargeForm(editRecurringChargeForm)
  }

  function onSubmit() {
    dispatch({ type: 'BEGIN_SUBMIT_EDIT_RECURRING_CHARGE' })
    if (has_credit_card_to_charge === 'yes' && payment_source.kind === 'other_card') {
      createNewPaymentSource()
    } else {
      dispatch(updateRecurringCharge())
    }
  }

  function onErrors() {

  }

  function onDelete() {
    dispatch(deleteRecurringCharge())
  }

  function createNewPaymentSource() {
    props.stripe.createToken({ name: 'Name' }).then(stripeResponse => {
      if (stripeResponse.error) {
        dispatch({ type: 'FAILED_SUBMIT_EDIT_RECURRING_CHARGE', payload: [stripeResponse.error.message] })
        return false
      } else {
        $.ajax({
          url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources.json`,
          method: 'POST',
          data: {
            payment_source: {
              kind: 'card',
              stripe_token_id: stripeResponse.token.id,
              stripe_source_id: stripeResponse.token.card.id,
              last4: stripeResponse.token.card.last4,
              brand: stripeResponse.token.card.brand,
            }
          },
          success: (payment_source) => {
            dispatch({ type: 'ADD_PAYMENT_SOURCE', payload: payment_source })
            dispatch(updateEditRecurringChargeField({ payment_source }))
            dispatch(updateRecurringCharge(props.stripe))
          },
          error: xhr => {
            const errors = $.parseJSON(xhr.responseText).errors
            dispatch({ type: 'FAILED_SUBMIT_EDIT_RECURRING_CHARGE', payload: errors })
          }
        });
      }
    })
  }

  function handleChangeHasCreditCardToCharge(e) {
    updateEditRecurringChargeField({
      has_credit_card_to_charge: e.value,
      invoice_client: 'no',
      payment_source: null,
      email: null,
      due_days_after_invoice: null,
    })
  }

  function handleChangeInvoiceClient(e) {
    // if the user at some point wanted to charge a card but then changed there mind
    // and decided to invoice the resident, we have to make sure
    // the payment source is cleared so it doesn't associate a payment source with the recurring charge.
    // We have to do the same if the user at some point wanted to send an email but now changed
    // their mind and wants to bill via a credit card instead of generating an invoice.
    updateEditRecurringChargeField({
      invoice_client: e.value,
      email: e.value == 'yes' ? paymentSources.email : '',
      payment_source: null,
    })
  }

  useEffect(() => {
    updateEditRecurringChargeField({
      has_credit_card_to_charge: payment_method === 'online' ? 'yes' : 'no',
    })

    !!email ?
      updateEditRecurringChargeField({ invoice_client: 'yes' }) :
      updateEditRecurringChargeField({ invoice_client: 'no' })

    !!receipt_email ?
      updateEditRecurringChargeField({ email_receipt_to_payer: 'yes' }) :
      updateEditRecurringChargeField({ email_receipt_to_payer: 'no' })

    !send_email_number_of_days_before_due_date &&
      updateEditRecurringChargeField({ send_email_number_of_days_before_due_date: due_days_after_invoice })
  }, [id])


  return (
    <FormModal
      show={show}
      title="Edit Recurring Charge"
      isSubmitting={is_submitting}
      isDeleting={is_deleting}
      deleteButtonLabel="Stop"
      submitButtonLabel="Close"
      showCancel={false}
      errors={errors}
      handleClose={onClose}
      handleValidateRequiredFields={onValidateRequiredFields}
      handleSubmit={onSubmit}
      handleDelete={onDelete}
      handleErrors={onErrors}>
      {is_stripe && <div className="pb-2"><div className="badge bg-secondary">STRIPE</div></div>}
      <FormInput
        disabled
        label="Memo"
        value={name} />
      <FormInput
        disabled
        label="Amount"
        value={moneyize(amount)} />
      <Scheduler
        disabled
        showScheduleDate={false}
        hasNumbers={false}
        isIndented={false}
        starts_at={starts_at}
        ends_at={ends_at}
        interval_count={interval_count}
        interval={interval}
        end_type={end_type}
        occurrences={occurrences} />
      <FormInput
        disabled={true}
        label="Will you be charging a credit card?"
        type="select"
        placeholder="Yes or No?.."
        options={[{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }]}
        value={has_credit_card_to_charge == 'yes' ? { label: 'Yes', value: 'yes' } : { label: 'No', value: 'no' }}
        handleChange={(e) => handleChangeHasCreditCardToCharge(e)} />
      {has_credit_card_to_charge == 'yes' &&
        <div>
          <SelectPaymentOptions
            disabled={is_cancelled}
            label="Select Payment Source"
            showNewPaymentMethodButton={false}
            hasOtherCardOption
            hasBalanceOption={false}
            value={payment_source}
            handlePaymentSourceChange={(payment_source) => updateEditRecurringChargeField({ payment_source })} />
          {payment_source && payment_source.kind == 'other_card' &&
            <FormInput
              label="Enter Credit Card Information"
              type='credit_card' />
          }
        </div>
      }
      {
        invoice_client == 'yes' && has_credit_card_to_charge == 'no' &&
        <div>
          <FormInput
            disabled={true}
            label="Invoice emailed to"
            placeholder="example@me.com"
            value={email}
            handleChange={(email) => updateEditRecurringChargeField({ email })} />
        </div>
      }
      {
        email_receipt_to_payer == 'yes' &&
        <FormInput
          disabled
          label="Receipt emailed to"
          value={receipt_email}
          placeholder="Enter client email"
          handleChange={(receipt_email) => updateEditRecurringChargeField({ receipt_email })} />
      }
      {
        email_receipt_to_payer == 'yes' &&
        <FormInput
          disabled
          label="Invoice Note"
          value={receipt_note} />
      }
      <hr />
      {
        moment(first_issue_date).startOf('day').toISOString() != moment(first_due_date).startOf('day').toISOString() &&
        <FormInput
          disabled
          label={`First invoice ${invoice_client == 'yes' ? 'emailed' : 'created'} on`}
          value={moment(first_issue_date).format("MMMM D, YYYY")} />
      }
      <FormInput
        disabled
        label="First invoice due on"
        value={moment(first_due_date).format("MMMM D, YYYY")} />
      <hr />
      {
        moment(first_issue_date).startOf('day').toISOString() != moment(first_due_date).startOf('day').toISOString() &&
        <FormInput
          disabled
          label={`Next invoice ${invoice_client == 'yes' ? 'emailed' : 'created'} on`}
          value={moment(next_issue_date).format("MMMM D, YYYY")} />
      }
      <FormInput
        disabled
        label="Next invoice due on"
        value={moment(next_due_date_that_hasnt_been_issued).format("MMMM D, YYYY")} />
      <p className="text-secondary">
        For transparency and security purposes, you cannot edit recurring charge. If you wish to make a change, stop this recurring charge and create a new one with the desired properties.
      </p>
    </FormModal>
  )
}

export default injectStripe(EditRecurringCharge)
